import { c as _c } from "react/compiler-runtime";
import { getOrgProxyConfigsOptions } from '@onefootprint/fetch-dashboard';
import type { ExternalApiSource } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import useSession from '@/hooks/use-session';
const useProxyConfigs = nodeDataSource => {
  const $ = _c(14);
  const {
    data: session
  } = useSession();
  const isSandboxRestricted = session.org?.isSandboxRestricted;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getOrgProxyConfigsOptions({
      headers: {
        "x-is-live": "true"
      }
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !isSandboxRestricted;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      ...t0,
      enabled: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: proxyConfigs,
    isLoading: isLoadingLiveProxyConfigs
  } = useQuery(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getOrgProxyConfigsOptions({
      headers: {
        "x-is-live": "false"
      }
    });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: sandboxProxyConfigs,
    isLoading: isLoadingSandboxProxyConfigs
  } = useQuery(t3);
  const proxyConfigId = typeof nodeDataSource === "object" && "proxy" in nodeDataSource ? nodeDataSource.proxy.configId : undefined;
  const sandboxProxyConfigId = typeof nodeDataSource === "object" && "proxy" in nodeDataSource ? nodeDataSource.proxy.sandboxConfigId : undefined;
  let t4;
  if ($[4] !== proxyConfigId || $[5] !== proxyConfigs) {
    t4 = proxyConfigs?.find(t5 => {
      const {
        id
      } = t5;
      return id === proxyConfigId;
    });
    $[4] = proxyConfigId;
    $[5] = proxyConfigs;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const proxyConfig = t4;
  let t5;
  if ($[7] !== sandboxProxyConfigId || $[8] !== sandboxProxyConfigs) {
    t5 = sandboxProxyConfigs?.find(t6 => {
      const {
        id: id_0
      } = t6;
      return id_0 === sandboxProxyConfigId;
    });
    $[7] = sandboxProxyConfigId;
    $[8] = sandboxProxyConfigs;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const sandboxProxyConfig = t5;
  const t6 = isLoadingSandboxProxyConfigs || isLoadingLiveProxyConfigs;
  let t7;
  if ($[10] !== proxyConfig || $[11] !== sandboxProxyConfig || $[12] !== t6) {
    t7 = {
      isLoading: t6,
      proxyConfig,
      sandboxProxyConfig
    };
    $[10] = proxyConfig;
    $[11] = sandboxProxyConfig;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default useProxyConfigs;